var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Typography, Zoom } from '@mui/material';
import Link from '@mui/material/Link';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../store/store';
export default function Copyright() {
    var _this = this;
    var _a = useState(0), count = _a[0], setCount = _a[1];
    var _b = useState(false), clicked = _b[0], setClicked = _b[1];
    var auth = useAppSelector(function (store) { return store.auth; });
    useEffect(function () {
        var getData = setTimeout(function () {
            setCount(0);
        }, 2000);
        return function () { return clearTimeout(getData); };
    }, [count]);
    var onClick = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (inc) {
            if (inc === void 0) { inc = 1; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setCount(count + inc);
                        if (!(count > 4)) return [3 /*break*/, 2];
                        setClicked(true);
                        setInterval(function () { return setClicked(false); }, 5000);
                        return [4 /*yield*/, navigator.clipboard.writeText(auth.token || 'Please login first!')];
                    case 1:
                        _a.sent();
                        setCount(0);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return (_jsx(Box, { sx: {
            marginBottom: '1rem',
            marginTop: 'auto'
        }, children: _jsxs(_Fragment, { children: [_jsx(Zoom, { in: clicked, mountOnEnter: true, unmountOnExit: true, children: _jsx(Typography, { align: "center", sx: { fontWeight: '700' }, children: "Token copied" }) }), _jsxs(Typography, { variant: "body2", align: "center", sx: { userSelect: 'none', color: '#b1b1b1' }, children: [_jsxs("span", { onClick: function () { return onClick(1); }, onDoubleClick: function () { return onClick(2); }, children: ["Copyright \u00A9", ' '] }), _jsx(Link, { color: "inherit", href: "https://pricer.com/", children: "Pricer" }), _jsxs("span", { onClick: function () { return onClick(1); }, onDoubleClick: function () { return onClick(2); }, children: [' ', new Date().getFullYear(), "."] })] })] }) }));
}
